export const TabType = {
    CLASSROOM: "classroom",
    COURSE: "course",
}